import useTasksStore from '@/common/store/pinia/tasks';
import { store } from '@/common/root';
import {
  Store,
  StoreActions,
  StoreGetters,
  StoreOnActionListenerContext,
  StoreState
} from 'pinia';

type Subscription<S extends Store> = {
  store: S;
  actionsMap: {
    [key in keyof StoreActions<S>]?: (ctx: StoreOnActionListenerContext<S['$id'], StoreState<S>, StoreGetters<S>, StoreActions<S>>) => void;
  };
}

const subscribeToActions = <S extends Store>(subscriptions: Subscription<S>[]) => {
  subscriptions.forEach(({ store: piniaStore, actionsMap }) => {
    piniaStore.$onAction((ctx) => actionsMap[ctx.name]?.(ctx));
  });
};

export default () => {
  subscribeToActions([
    {
      store: useTasksStore(),
      actionsMap: {
        fetchItems: ({ after }) => after(
          ({ data }) => data.forEach(task => store.dispatch('notifications/REVEAL_TASK', task))
        ),
        fetchItem: ({ after }) => after(
          ({ data }) => store.dispatch('notifications/REVEAL_TASK', data)
        )
      }
    }
  ]);
};
